import React, { useState, useEffect, useRef, useContext } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

import '../../sass/mobile-header.scss';
import { useWindowDimension } from '../../hooks/windowDimensions';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../../mobilecomponents/global-context';
import { publish, subscribe } from 'pubsub-js';
import { MobileContext } from '../../mobilecomponents/global-context';
import { getNameAndAccountID } from '../../mobilecomponents/getNameAndAccountNumber';
import { useHistory } from 'react-router-dom';
import myeirLogo from '../../sharedcomponents/images/LOGO.png';
import myeirLogoMobile from '../../sharedcomponents/images/LOGOM.png';
import hamMenuBackground from '../../sharedcomponents/images/navigation_M.png';
import { getMsisdns } from '../redesign-5.2/sim-replacement/simReplacement.util';
import { clearAllCookies, triggerAdobeApi } from './redesign.api';
import EirButton from '../../theme/EirButton';

function MobileHeaderRedesign(props) {
    const [width, height] = useWindowDimension();
    const logoRef = useRef(null);
    const [isopen, setIsOpen] = useState(false);
    const [isLoggedIn, setLogIn] = useState(true);
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [accountNumber, setAccountNumber] = useState();
    const [retryAPIcall, setRetryAPIcall] = useState(4);
    const value = useContext(MobileContext);
    const graphql = useApolloClient();
    const history = useHistory();
    const [msisdnVal, setMsisdnVal] = useState([]);
    const toggle = () => {
        setIsOpen(!isopen);
    };
    const toggleLogIn = () => setLogIn(!isLoggedIn);
    // for future use keeping it as it is
    const onNavClick = (navItem, actionType) => {
        navItem >= 0 && value.dispatch({ type: actionType, payload: navItem });
        if (!(location.href.indexOf('/account/dashboard') > -1)) {
            history.push('/account/dashboard');
        }

        setIsOpen(!isopen);
    };

    const truncate = (text, limit = 10) => {
        return text?.length > limit ? text.slice(0, limit) + '...' : text;
    };

    const handleClickClose = () => {
        history.push('/account/dashboard');
        toggle();
    };

    useEffect(() => {
        subscribe('openhamburger', toggle);
        // subscribe('closehamburger', handleClickClose);
    }, []);

    async function getNameAndAccountNumber() {
        if (
            sessionStorage.getItem('LoggedinUserFirstName') == undefined ||
            sessionStorage.getItem('LoggedinUserLastName') == undefined ||
            sessionStorage.getItem('LoggedinUserAccountNumber') == undefined ||
            sessionStorage.getItem('LoggedinUserAccountNumber') == ''
        ) {
            const response = await getNameAndAccountID(graphql);
            // console.log('response[0]', response[0]);
            if (
                sessionStorage.getItem('LoggedinUserFirstName') == undefined ||
                sessionStorage.getItem('LoggedinUserLastName') == undefined ||
                sessionStorage.getItem('LoggedinUserAccountNumber') == undefined ||
                sessionStorage.getItem('LoggedinUserAccountNumber') == ''
            ) {
                setTimeout(function () {
                    // console.log('retrying to fetch Name and Account number');
                    // console.log('number of retries left', retryAPIcall - 1);
                    setRetryAPIcall(retryAPIcall - 1);
                }, 10000);
            }
            if (
                sessionStorage.getItem('LoggedinUserAccountNumber') != undefined &&
                sessionStorage.getItem('LoggedinUserAccountNumber') != ''
            ) {
                setAccountNumber(String(sessionStorage.getItem('LoggedinUserAccountNumber')));
            }

            if (sessionStorage.getItem('LoggedinUserFirstName') != undefined) {
                setFirstName(sessionStorage.getItem('LoggedinUserFirstName'));
            }

            if (sessionStorage.getItem('LoggedinUserLastName') != undefined) {
                setLastName(sessionStorage.getItem('LoggedinUserLastName'));
            }
        } else {
            setAccountNumber(String(sessionStorage.getItem('LoggedinUserAccountNumber')));
            setFirstName(sessionStorage.getItem('LoggedinUserFirstName'));
            setLastName(sessionStorage.getItem('LoggedinUserLastName'));
        }
    }

    const getMisisdnsUtil = async () => {
        await getMsisdns({ setMsisdnVal });
    };

    useEffect(() => {
        // console.log('mobile header useeffect 1')
        if (props.loginSuccess == true) {
            getNameAndAccountNumber();
        }
    }, [props.loginSuccess]);

    useEffect(() => {
        // console.log('mobile header useeffect 2')
        if (retryAPIcall > 0 && retryAPIcall < 4) {
            getNameAndAccountNumber();
        }
    }, [retryAPIcall]);

    useEffect(() => {
        getMisisdnsUtil();
    }, []);

    const handleContracts = async () => {
        history.push('/account/contracts');
        toggle();
        const contractfetch = await triggerAdobeApi({ graphql, name: 'contract' });
    };

    const handlePreferences = async () => {
        history.push('/account/preferences');
        toggle();
        const preferencesfetch = await triggerAdobeApi({ graphql, name: 'prefer' });
    };

    useEffect(() => {
        // logoRef.current?.focus();
        if (!props.loginSuccess || isopen) return;

        const handleFirstTab = event => {
            if (event.key === 'Tab' && !event.shiftKey) {
                event.preventDefault();
                logoRef?.current?.focus();
                const sweeprWidget = document.querySelector('#sweepr-widget iframe');
                if (sweeprWidget) {
                    sweeprWidget.focus();
                } else {
                    logoRef?.current?.focus();
                }

                document.removeEventListener('keydown', handleFirstTab);
            }
        };

        document.addEventListener('keydown', handleFirstTab);

        return () => {
            document.removeEventListener('keydown', handleFirstTab);
        };
    }, [props.loginSuccess, isopen]);

    return (
        <div
            className='my-eir-header-container'
            style={
                props.loginSuccess
                    ? {}
                    : {
                          background:
                              'linear-gradient(180deg, rgba(27, 0, 41, 0.75) 0%, rgba(27, 0, 41, 0) 97.49%)',
                      }
            }
        >
            <div className='my-eir-header'>
                <h1
                    ref={logoRef}
                    onClick={() => {
                        // location.href = 'https://my.eir.ie';
                        history.push('/account/dashboard');
                    }}
                    className='my-eir-logo'
                    role='link'
                    tabIndex='0'
                    variant='h1'
                    component='h1'
                >
                    <picture>
                        <source media='(max-width: 599px)' srcSet={myeirLogoMobile} />
                        <img src={myeirLogo} alt='eir logo in white' id='eir-logo' />
                    </picture>
                </h1>
                {props.loginSuccess &&
                    (window.location.href.indexOf('/account') > -1 ||
                        window.location.href.indexOf('/help') > -1) && (
                        <div className='modal-test'>
                            <div className='account-information'>
                                <div className='account-name'>
                                    {!!firstName && <>{firstName}&nbsp;</>}
                                    {!!lastName && lastName}
                                </div>
                                <div className='my-account-text'>My account</div>
                            </div>
                            <React.Fragment>
                                <div
                                    className={'burger-menu' + (isopen ? ' open' : '')}
                                    onClick={toggle}
                                    tabIndex={!isopen ? 0 : ''}
                                    role='button'
                                    aria-controls='secondary-navigation'
                                    aria-label={
                                        !isopen
                                            ? 'secondary-navigation open-menu'
                                            : 'secondary-navigation close-popup'
                                    }
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            toggle();
                                        }
                                    }}
                                >
                                    <div className='burger-menu-button' aria-hidden='true'></div>
                                </div>
                                <Modal
                                    className='hamBmain'
                                    wrapClassName='hamBwrap'
                                    modalClassName='hamBmodal'
                                    backdropClassName='hamBbackdrop'
                                    contentClassName='hamBcontent'
                                    isOpen={isopen}
                                    toggle={toggle}
                                    role='dialog'
                                    aria-modal='true'
                                    modalTransition={{ timeout: 300 }}
                                >
                                    <ModalBody
                                        className='hamBbody'
                                        // style={{
                                        //     background: `url(${hamMenuBackground}) no-repeat`,
                                        //     backgroundSize: '100% 143%',
                                        // }}
                                    >
                                        <div
                                            className='hamburger-menu'
                                            aria-label='secondary-navigation'
                                        >
                                            {/* CLOSE BUTTON */}
                                            <div
                                                className={'burger-menu' + (!isopen ? ' open' : '')}
                                                role='button'
                                                tabIndex={width < 600 ? 0 : ''}
                                                // aria-controls='secondary-navigation'
                                                aria-label='close-popup'
                                                onClick={width < 600 ? toggle : undefined}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        toggle();
                                                    }
                                                }}
                                            >
                                                <div
                                                    className='burger-menu-button'
                                                    role='button'
                                                    tabIndex={0}
                                                    aria-controls='secondary-navigation'
                                                    aria-label='close-popup'
                                                    onClick={toggle}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            toggle();
                                                        }
                                                    }}
                                                ></div>
                                            </div>
                                            <div className='account-information'>
                                                <div className='account-name'>
                                                    {!!firstName && <>{firstName}&nbsp;</>}
                                                    {!!lastName && lastName}
                                                </div>
                                                <div className='account-number'>
                                                    {!!accountNumber && (
                                                        <>Account number: {accountNumber}</>
                                                    )}
                                                </div>
                                            </div>

                                            <div className='account-navigations'>
                                                <div
                                                    className='account-navigations-home'
                                                    onClick={handleClickClose}
                                                    tabIndex={0}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' || e.key === '') {
                                                            e.preventDefault();
                                                            handleClickClose();
                                                        }
                                                    }}
                                                    aria-label='Home'
                                                    role='link'
                                                >
                                                    <span style={{ cursor: 'pointer' }}>Home</span>
                                                </div>

                                                <div
                                                    className='account-navigations-eir-account'
                                                    onClick={() => {
                                                        history.push('/account/details');
                                                        toggle();
                                                    }}
                                                    tabIndex={0}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' || e.key === '') {
                                                            e.preventDefault();
                                                            history.push('/account/details');
                                                            toggle();
                                                        }
                                                    }}
                                                    aria-label='Account details'
                                                    role='link'
                                                >
                                                    <span style={{ cursor: 'pointer' }}>
                                                        Account details
                                                    </span>
                                                </div>

                                                <div
                                                    className='account-navigations-Contracts'
                                                    onClick={handleContracts}
                                                    tabIndex={0}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' || e.key === '') {
                                                            e.preventDefault();
                                                            handleContracts();
                                                        }
                                                    }}
                                                    aria-label='Contracts'
                                                    role='link'
                                                >
                                                    <span style={{ cursor: 'pointer' }}>
                                                        Contracts
                                                    </span>
                                                </div>
                                                <div className='account-preferences'>
                                                    <div
                                                        className='account-navigations-Preferences'
                                                        onClick={handlePreferences}
                                                        tabIndex={0}
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === '') {
                                                                e.preventDefault();
                                                                handlePreferences();
                                                            }
                                                        }}
                                                        aria-label='Preferences'
                                                        role='link'
                                                    >
                                                        <span style={{ cursor: 'pointer' }}>
                                                            Preferences
                                                        </span>
                                                    </div>
                                                </div>
                                                {msisdnVal?.length !== 0 && (
                                                    <div
                                                        className='account-navigations-simReplacement'
                                                        onClick={() => {
                                                            if (
                                                                JSON.parse(
                                                                    sessionStorage.getItem(
                                                                        'LoggedinUserFeatures'
                                                                    ) || '[]'
                                                                )?.filter(
                                                                    feature =>
                                                                        feature?.feature_name ===
                                                                        'esim'
                                                                )?.length > 0
                                                            ) {
                                                                history.push('/account/manage-sim');
                                                                toggle();
                                                            } else {
                                                                history.push(
                                                                    '/account/simreplacement'
                                                                );
                                                                toggle();
                                                            }
                                                        }}
                                                        tabIndex={0}
                                                        onKeyDown={e => {
                                                            if (e.key === 'Enter' || e.key === '') {
                                                                e.preventDefault();
                                                                if (
                                                                    JSON.parse(
                                                                        sessionStorage.getItem(
                                                                            'LoggedinUserFeatures'
                                                                        ) || '[]'
                                                                    )?.filter(
                                                                        feature =>
                                                                            feature?.feature_name ===
                                                                            'esim'
                                                                    )?.length > 0
                                                                ) {
                                                                    history.push(
                                                                        '/account/manage-sim'
                                                                    );
                                                                    toggle();
                                                                } else {
                                                                    history.push(
                                                                        '/account/simreplacement'
                                                                    );
                                                                    toggle();
                                                                }
                                                            }
                                                        }}
                                                        aria-label='Manage SIM & eSIM'
                                                        role='link'
                                                    >
                                                        {JSON.parse(
                                                            sessionStorage.getItem(
                                                                'LoggedinUserFeatures'
                                                            ) || '[]'
                                                        )?.filter(
                                                            feature =>
                                                                feature?.feature_name === 'esim'
                                                        )?.length > 0 ? (
                                                            <span style={{ cursor: 'pointer' }}>
                                                                {/* Enable eSIM feature */}
                                                                Manage SIM & eSIM
                                                            </span>
                                                        ) : (
                                                            <span style={{ cursor: 'pointer' }}>
                                                                {/* Enable eSIM feature */}
                                                                SIM replacement
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                                <div
                                                    className='account-navigations-help'
                                                    onClick={() => {
                                                        history.push('/help');
                                                        toggle();
                                                    }}
                                                    tabIndex={0}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter' || e.key === '') {
                                                            e.preventDefault();
                                                            history.push('/help');
                                                            toggle();
                                                        }
                                                    }}
                                                    aria-label='Help'
                                                    role='link'
                                                >
                                                    <span style={{ cursor: 'pointer' }}>Help</span>
                                                </div>
                                            </div>
                                            <div className='signOutButton'>
                                                <EirButton
                                                    variants='primaryButtonMedium'
                                                    style={{ padding: '0.5rem 1.8rem' }}
                                                    // className='sign-out-button'
                                                    onClick={() => {
                                                        sessionStorage.clear();
                                                        clearAllCookies();
                                                        window.location.href = '/';
                                                    }}
                                                    aria-label='Sign out'
                                                    role='button'
                                                >
                                                    Sign out
                                                    {/* <ArrowForwardIcon className='sign-out-arrow' /> */}
                                                </EirButton>
                                            </div>
                                        </div>
                                    </ModalBody>
                                </Modal>
                            </React.Fragment>
                        </div>
                    )}
            </div>
        </div>
    );
}
export default MobileHeaderRedesign;
